<div class="payment-choices-listing d-flex flex-column flex-sm-row">

  <ng-container *ngIf="areFullPaymentOnlineOrInSalonChoicesVisible"
                [ngTemplateOutlet]="paymentMethodChoiceTemplate"
                [ngTemplateOutletContext]="{
                  paymentMethodName: PaymentType.Online,
                  isSelected: paymentMethod === PaymentType.Online,
                  translation: 'BOOKING-PART.STEPS.CUSTOMER-DATA.PAYMENT-METHOD.PAY-ONLINE'}">
  </ng-container>

  <ng-container *ngIf="areFullPaymentOnlineOrInSalonChoicesVisible"
                [ngTemplateOutlet]="paymentMethodChoiceTemplate"
                [ngTemplateOutletContext]="{
                paymentMethodName: PaymentType.InSalon,
                isSelected: paymentMethod === PaymentType.InSalon,
                translation: 'BOOKING-PART.STEPS.CUSTOMER-DATA.PAYMENT-METHOD.PAY-IN-SALON'}">
  </ng-container>

  <ng-container *ngIf="isDownPaymentOnlineChoiceVisible"
                [ngTemplateOutlet]="paymentMethodChoiceTemplate"
                [ngTemplateOutletContext]="{
                paymentMethodName: PaymentType.DownPaymentOnline,
                displayPrice: downPaymentRequiredAmount,
                isSelected: paymentMethod === PaymentType.DownPaymentOnline,
                translation: 'BOOKING-PART.STEPS.CUSTOMER-DATA.PAYMENT-METHOD.DOWN-PAYMENT-ONLINE'}">
  </ng-container>

  <ng-container *ngIf="areDownPaymentOnlineOrFullPaymentOnlineChoicesVisible"
                [ngTemplateOutlet]="paymentMethodChoiceTemplate"
                [ngTemplateOutletContext]="{
                paymentMethodName: PaymentType.Online,
                isSelected: paymentMethod === PaymentType.Online,
                translation: 'BOOKING-PART.STEPS.CUSTOMER-DATA.PAYMENT-METHOD.FULL-PAYMENT-ONLINE'}">
  </ng-container>
</div>

<div class="bg-gray-100 d-flex justify-content-left p-3 text-muted">
  <ng-container [ngSwitch]="paymentMethod">
    <ng-container *ngSwitchCase="PaymentType.InSalon">
      <span [translate]="'BOOKING-PART.STEPS.CUSTOMER-DATA.PAYMENT-METHOD.PAY-IN-SALON-EXPLANATION'"></span>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <div class="row d-flex align-items-center text-center">
        <div class="col-3">
          <img class="img-fluid"
               src="assets/img/payment-vendors/ideal.png">
        </div>
        <div class="col-4">
          <img class="img-fluid"
               src="assets/img/payment-vendors/visa.png">
        </div>
        <div class="col-5">
          <img class="img-fluid"
               src="assets/img/payment-vendors/mastercard.png">
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #paymentMethodChoiceTemplate
             let-paymentMethodName="paymentMethodName"
             let-isSelected="isSelected"
             let-imageSrc="imageSrc"
             let-translation="translation"
             let-displayPrice="displayPrice">
  <a class="payment-choice-container me-sm-3 mb-3"
     [ngClass]="{'payment-choice-selected': isSelected}"
     href="#"
     role="checkbox"
     (click)="selectPaymentMethod(paymentMethodName); false"
     [attr.aria-checked]="isSelected">
    <div class="card"
         [ngClass]="{'border-primary': isSelected}">
      <div class="card-body py-0 d-flex align-items-center">
        <ng-container *ngIf="isSelected"
                      [ngTemplateOutlet]="IconTickCheckState">
        </ng-container>

        <ng-container *ngIf="!isSelected"
                      [ngTemplateOutlet]="IconTickEmptyState">
        </ng-container>

        <div class="d-flex flex-row align-items-center">
          <ng-container [ngSwitch]="paymentMethodName">
            <ng-container [ngTemplateOutlet]="IconPayInSalon"
                          *ngSwitchCase="PaymentType.InSalon">
            </ng-container>
            <ng-container [ngTemplateOutlet]="IconDownPayment"
                          *ngSwitchCase="PaymentType.DownPaymentOnline">
            </ng-container>
            <ng-container [ngTemplateOutlet]="IconPaymentOnline"
                          *ngSwitchDefault>
            </ng-container>
          </ng-container>
          <span class="d-flex flex-column ms-2 text-start"
                [ngClass]="{'text-primary': isSelected,
                'text-secondary': !isSelected}">
            <span [translate]="translation">
            </span>
            <span *ngIf="displayPrice">
              {{ displayPrice | currency: 'EUR' }}
            </span>
          </span>
        </div>

      </div>
    </div>
  </a>
</ng-template>

<ng-template #IconPaymentOnline>
  <svg xmlns="http://www.w3.org/2000/svg"
       viewBox="0 0 24 24"
       class="icon-payment-online">
    <path d="M0 0h24v24H0z"
          fill="none" />
    <path
          d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" />
  </svg>
</ng-template>

<ng-template #IconPayInSalon>
  <svg xmlns="http://www.w3.org/2000/svg"
       viewBox="0 0 24 24"
       class="icon-pay-in-salon">
    <path d="M0 0h24v24H0z"
          fill="none" />
    <path d="M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z" />
  </svg>
</ng-template>

<ng-template #IconDownPayment>
  <svg class="icon-payment-online"
       viewBox="0 0 24 24"
       xmlns="http://www.w3.org/2000/svg">
    <path
          d="m14.58 15.65q0 1.306-0.603 1.935t-1.757 0.6292q-1.19 0-1.793-0.6345-0.5977-0.6397-0.5977-1.909 0-1.295 0.6135-1.919 0.6135-0.6292 1.778-0.6292 1.175 0 1.767 0.6292 0.5925 0.624 0.5925 1.898zm4.09-2.375-4.09 7.807h-1.41l4.09-7.807zm3.319 5.406q0 1.306-0.603 1.935t-1.757 0.6292q-1.19 0-1.793-0.6345-0.5977-0.6397-0.5977-1.909 0-1.295 0.6135-1.919 0.6135-0.6292 1.778-0.6292 1.175 0 1.767 0.6292 0.5925 0.624 0.5925 1.898zm-8.956-3.015q0-0.8389-0.194-1.133-0.194-0.2936-0.6345-0.2936t-0.6345 0.2936-0.194 1.138q0 0.8442 0.194 1.138t0.6345 0.2936 0.6345-0.2936q0.194-0.2936 0.194-1.143zm7.409 3.031q0-0.8389-0.194-1.133-0.194-0.2936-0.6345-0.2936-0.4404 0-0.6345 0.2936-0.194 0.2936-0.194 1.138t0.194 1.138 0.6345 0.2936q0.4404 0 0.6345-0.2936t0.194-1.143z" />
    <path
          d="m4 4c-1.11 0-1.99 0.89-1.99 2l-0.009766 12c0 1.11 0.89 2 2 2h5.404v-2h-5.404v-6h16v0.6699h2v-6.67c0-1.11-0.89-2-2-2zm0 2h16v2h-16z" />
  </svg>
</ng-template>

<ng-template #IconTickCheckState>
  <svg class="payment-choice-radio check-state"
       viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z"
          fill="none" />
    <path
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
  </svg>
</ng-template>

<ng-template #IconTickEmptyState>
  <svg class="payment-choice-radio empty-state"
       viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z"
          fill="none" />
    <path
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
  </svg>
</ng-template>
